import { ChevronRight, ChevronLeft } from "lucide-react";

const NavigationButtons = ({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext, 
  onSubmit, 
  isSubmitting,
  canSubmit 
}) => {
  return (
    <div className="flex justify-between mt-8 pt-6 border-t border-white/10">
      {currentStep > 1 ? (
        <button
          onClick={onPrevious}
          className="flex items-center gap-2 px-6 py-3 border border-white/20 text-white hover:bg-white/5 transition-colors"
          data-testid="prev-button"
        >
          <ChevronLeft className="w-5 h-5" />
          Previous
        </button>
      ) : (
        <div />
      )}
      
      {currentStep < totalSteps ? (
        <button
          onClick={onNext}
          className="flex items-center gap-2 btn-gold px-8 py-3"
          data-testid="next-button"
        >
          Next
          <ChevronRight className="w-5 h-5" />
        </button>
      ) : (
        <button
          onClick={onSubmit}
          disabled={isSubmitting || !canSubmit}
          className="flex items-center gap-2 btn-gold px-8 py-3 disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="submit-button"
        >
          {isSubmitting ? (
            <>
              <span className="spinner" />
              Submitting...
            </>
          ) : (
            "Get My Free Cash Offer"
          )}
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;
